import styled from 'styled-components';

export const PaginationContainer = styled.div`
	display: flex;
	height:30px;
	opacity: ${props => props.noResults || props.hide ? '0' :'1'};
	transition: 140ms;
	

	@media (min-width: 380px) {
		height: 40px;
	}
`;
export const PageNumberList = styled.ul`
	list-style: none;
	display: flex;
	margin: 0 15px;
`;

export const ListItem = styled.li`
	width: 27px;
	height: 100%;
	margin-right: 2px;
	display: ${(props) => (props.hidden ? 'none' : 'block')};

	@media (min-width: 380px) {
		width: 32px;
	}
`;

export const Number = styled.button`
	outline: none;
	font-size: 18px;
	cursor: pointer;
	padding: 0;
	background:none;
	color: ${(props) => (props.active ? props.theme.colors.teal : "#000")};
	font-weight: 600;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	border: ${(props) => (props.active ? `2px solid ${props.theme.colors.teal}` : '2px solid transparent')};
	transition: 80ms;

	:hover {
		color: ${(props) => props.theme.colors.teal};
	}
`;

export const PageIncrementButton = styled.button`
	display: inline-flex;
	background: ${(props) => (props.disabled ? props.theme.colors.grey[1] : props.theme.colors.pink)};
	border-radius: 2px;
	font-weight: 600;
	outline: none;
	border: none;
	font-size: 14px;
	padding: 0 18px;
	height: 100%;
	width: 50px;
	color: white;
	cursor: pointer;
	justify-content: center;
	align-items: center;
	text-align: center;
	pointer-events: ${(props) => props.disabled && 'none'};

	:hover {
		background: #C8295F;
		transition: 90ms;

	}

	@media (min-width: 380px) {
		width: 66px;
	}
`;
